export const APP_VERSION = '1780522432399';
